<style scoped>
.modal.oppay .pin-code {
    display: flex;
}

.pin-code input {
    border-radius: 0px !important;
    border: solid #ced4da 0.8px;
    flex-grow: 1;
    border-right: transparent;
}

.pin-code input:first-child {
    border-radius: 4px 0px 0px 4px !important;
}

.pin-code input:last-child {
    border-right: solid #ced4da 0.8px !important;
    border-radius: 0px 4px 4px 0px !important;
}

/*  This handles for hardcoded hover button */
.pin-code input:nth-last-of-type(3):focus,
.pin-code input:nth-last-of-type(2):focus,
.pin-code input:first-child:focus,
.pin-code input:last-child:focus {
    border: solid #3eccf1 1.5px;
}

.modal.oppay input {
    border-radius: 0px;
    text-align: center;
    font-size: 20px;
}

.modal.oppay .form-control.no-label {
    font-size: 25px !important;
    padding: 10px;
}
</style>
<template>
<div ref="pay-card-otp" id="pay-card-otp" class="opt-content-wrapper pay-pane active py-3 px-2">

    <div v-if="loading" class="py-5">
        <Spinner class="my-2 animate slideInTop" :color="client_info.colors.loading_spinner">
            Please wait while your transaction is processing...
        </Spinner>
    </div>

    <div v-else>
        <div v-if="view !='otp'">
            <h4 class="my-5 text-center" style="">You will be redirected to your card's issuer's verification page to authorize this payment.</h4>
        </div>
        <div v-else>
            <p>Please enter your 4-digit card pin to authorize this payment</p>
            <span class="invalid-feedback" :style="(errors.card_pin) ? 'display : inline' : ''">{{errors.card_pin}}</span>
            <div class="modal-body pb-1">
                <div class="row m-0">
                    <div class="col-12 px-0">
                        <div class="form-group text-center">
                            <div class="pin-code">
                                <input type="password" class="form-control no-label focus" v-model="card_pin1" ref="card_pin_input1" id="card_pin_input1" maxlength="1" placeholder="-" autocomplete="off" pattern="[0-9]{1}" required autofocus @focus="isFocus = true" @blur="isFocus = false" :style="{ border: (isFocus ? isFocusColor : '')  }" />

                                <input type="password" class="form-control no-label focus" v-model="card_pin2" ref="card_pin_input2" id="card_pin_input2" maxlength="1" placeholder="-" autocomplete="off" pattern="[0-9]{1}" required @focus="isFocus2 = true" @blur="isFocus2 = false" :style="{ border: (isFocus2 ? isFocus2Color : '') , borderColorRight : (isFocus2 ? 'solid' + appColor : '')  }" />

                                <input type="password" class="form-control no-label focus" v-model="card_pin3" ref="card_pin_input3" id="card_pin_input3" maxlength="1" placeholder="-" autocomplete="off" pattern="[0-9]{1}" required @focus="isFocus3 = true" @blur="isFocus3 = false" :style="{ border: (isFocus3 ? isFocus3Color : '')  }" />

                                <input type="password" class="form-control no-label focus" v-model="card_pin4" ref="card_pin_input4" id="card_pin_input4" maxlength="1" placeholder="-" autocomplete="off" pattern="[0-9]{1}" required @focus="isFocus4 = true" @blur="isFocus4 = false" :style="{ border: (isFocus4 ? isFocus4Color : '')  }" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row m-0">
                    <div class="col-12 px-0 mb-0">
                        <div class="form-group mb-0 text-center">
                            <a href="javascript:void(0)" class="text-tiny" @click.prevent="goBack"> Change Card</a>
                        </div>
                        <div class="form-group text-center mb-0 mt-4">
                            <button type="button" class="btn app-bg-color" :style="button_color" @click.prevent="validateCardPin" ref="btnActionPay" id="btnActionPay"> Pay Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import Spinner from './includes/Spinner.vue';

export default {
    name: 'Pin',
    props: ['appColor', 'client_info', 'button_color'],
    components: {
        Spinner
    },
    watch: {
        isFocus(newVal) {
            if (newVal)
                this.isFocusColor = 'solid 1px ' + this.appColor;
        },
        isFocus2(newVal) {
            if (newVal)
                this.isFocus2Color = 'solid 1px ' + this.appColor;
        },
        isFocus3(newVal) {
            if (newVal)
                this.isFocus3Color = 'solid 1px ' + this.appColor;
        },
        isFocus4(newVal) {
            if (newVal)
                this.isFocus4Color = 'solid 1px ' + this.appColor;
        },
        card_pin1: {
            handler: function (val, old) {
                val = val.trim()
                if (!isNaN(val) && val.length > 0) {
                    this.$refs.card_pin_input2.focus()
                }
            },
            deep: true
        },
        card_pin2: {
            handler: function (val, old) {
                val = val.trim()
                if (!isNaN(val) && val.length > 0) {
                    this.$refs.card_pin_input3.focus()
                }
            },
            deep: true
        },
        card_pin3: {
            handler: function (val, old) {
                val = val.trim()
                if (!isNaN(val) && val.length > 0) {
                    this.$refs.card_pin_input4.focus()
                }
            },
            deep: true
        },
        card_pin4: {
            handler: function (val, old) {
                val = val.trim()
                if (!isNaN(val) && val.length > 0) {
                    this.$refs.card_pin_input4.blur()
                }
            },
            deep: true
        }
    },
    created() {
        this.amount = this.$store.state.payload.transaction.amount
    },
    mounted() {
        this.isFocusColor = 'solid 1px ' + this.appColor;
        if(this.$refs.card_pin_input1)
            this.$refs.card_pin_input1.focus();
        this.provider = this.$store.state.provider;
    },
    data() {
        return {
            card_pin: '',
            card_pin1: '',
            card_pin2: '',
            card_pin3: '',
            card_pin4: '',
            isFocus: true,
            isFocus2: false,
            isFocus3: false,
            isFocus4: false,
            isFocusColor: '',
            isFocus2Color: '',
            isFocus3Color: '',
            isFocus4Color: '',
            loadingMessage: 'Processing Transaction',
            // disabled: true,
            provider: null,
            amount: 0,
            loading: false,
            view: 'otp',
            initial_redirect_data: null,
            errors: {
                card_pin: false,
            }
        }
    },
    methods: {
        goBack() {
            this.$parent.changeComponent('CardPayment');
            this.loading = false;
        },

        validateCardPin() {
            this.card_pin = `${this.card_pin1}${this.card_pin2}${this.card_pin3}${this.card_pin4}`

            if (this.card_pin.length < 4) {
                this.errors.card_pin = 'Pin must be 4 digits';
                return;
            }

            this.validate();
        },

        setupredirect(url) {
            let isLocalhost = window.location.hostname === 'localhost',
                response = {
                    'status': 'redirect',
                    'data': {
                        'transaction': this.$store.state.payload.transaction,
                        'redirectUrl': isLocalhost ?
                            'http://redirect.md/' : `${this.provider.custom_ui_url}?appName=${this.$store.state.app_info.name}`,
                        "callback_url": isLocalhost ?
                            'http://redirect.md/' : this.provider.callback_url,
                        'chargeUrl': url,
                        'sourceUrl': isLocalhost ?
                            'http://onepipejs.md/inline-v2.min.js' : 'https://js.dev.onepipe.io/v2', //window.parent.location.href,
                        'provider': this.provider,
                    }
                }
            this.$parent.componentId = "";
            window.parent.postMessage(JSON.stringify(response), '*');
            this.$parent.in_view = '';
        },
        handleRedirect(provider_response, message) {
            if (provider_response != null && Object.keys(provider_response).includes('meta') && provider_response.meta && Object.keys(provider_response.meta).includes('redirect_url')) {
                this.view = '3dsecure'
                this.loadingMessage = 'Redirecting.. please wait'
                setTimeout(() => {
                    this.loading = true;
                    setTimeout(() => {
                        this.setupredirect(provider_response.meta.redirect_url);
                    }, 2000);
                }, 4000)

                return;
            }

            this.$parent.changeComponent('OTP', {
                message,
            });
        },
        validate() {
            let payload = this.$store.state.payload;
            payload.auth = {
                type: 'card',
                secure: `${this.$store.state.card_cc};${this.$store.state.card_cvv};${this.$store.state.card_exp};${this.card_pin}`,
                // auth_provider: 'Quickteller'
            }

            if (Object.keys(this.provider).includes('provider') && this.provider.provider != null) {
                payload.auth.auth_provider = this.provider.provider;
            }

            payload.transaction.transaction_ref = this.$store.state.transRef
            if (this.$store.state.isFailed)
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef

            // Append Transaction Ref into transaction_desc
            // Eg. 23489490AB_Payment for airtime purchase
            if (Object.keys(payload.transaction).includes('transaction_desc'))
                payload.transaction.transaction_desc = `${payload.transaction.transaction_ref}_${payload.transaction.transaction_desc}`;

            let data2 = {
                endpoint: 'transact',
                api_key: this.$store.state.api_key,
                payload
            };

            delete data2.payload.api_key;
            delete data2.payload.hasTLSFallback
            delete data2.payload.mode
            let dataPayload = this.$generateToken(data2);

            this.submitDetails(dataPayload)
        },
        submitDetails(dataPayload) {

            this.loading = true;

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data: dataPayload
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    Authorization: `Bearer ${this.$store.state.payload.api_key}`
                }).then(({
                    data
                }) => {

                    this.trx_otp = '';

                    let hash = data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;
                    window.raw = JSON.stringify(res);
                    this.loading = false;

                    if (status == "successful") {
                        return this.$parent.changeComponent('Status', {
                            reference: responseData.provider_response.reference,
                            type: 'Successful',
                            data: responseData,
                            message
                        });

                    } else if (['pendingvalidation','waitingforotp'].includes(status)) {
                        return this.handleRedirect(responseData.provider_response, message);
                    }

                    window.failedFromStartMessage = message || "An error occured from the main server, please try again or contact the webmaster hussien@onepipe.io."
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');

                })
                .catch(error => {
                    window.raw = JSON.stringify(error);
                    window.failedFromStart = false;
                    window.failedFromStartMessage = error;
                    this.$router.push('/v2/warning');
                })
        }
    }

}
</script>
